import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { PainIdentificationSection } from './sections/PainIdentificationSection';
import { DeepFearsSection } from './sections/DeepFearsSection';
import { ProductDescriptionSection } from './sections/ProductDescriptionSection';
import { ContentsSection } from './sections/ContentsSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { AudienceSection } from './sections/AudienceSection';
import { FAQSection } from './sections/FAQSection';
import { PricingSection } from './sections/PricingSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { PopNotification } from './components/PopNotification';
import { MobileBanner } from './components/MobileBanner';
export function App() {
  return <div className="min-h-screen font-body text-warmBrown bg-cream selection:bg-softGold/30 pt-10 md:pt-0" data-id="element-0">
      <MobileBanner data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainIdentificationSection data-id="element-4" />
        <DeepFearsSection data-id="element-5" />
        <ProductDescriptionSection data-id="element-6" />
        <ContentsSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <AudienceSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <FinalCTASection data-id="element-12" />
      </main>

      <footer className="py-10 bg-[#2D2D2D] text-gray-400 text-sm" data-id="element-13">
        <div className="max-w-4xl mx-auto px-6 flex flex-col items-center gap-6" data-id="element-14">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-gray-300" data-id="element-15">
            <a href="#" className="hover:text-white transition-colors" data-id="element-16">
              Términos y Condiciones
            </a>
            <span className="hidden sm:inline" data-id="element-17">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-18">
              Privacidad
            </a>
            <span className="hidden sm:inline" data-id="element-19">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-20">
              Cookies
            </a>
            <span className="hidden sm:inline" data-id="element-21">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-22">
              Configurar cookies
            </a>
            <span className="hidden sm:inline" data-id="element-23">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-24">
              Reembolsos y devoluciones
            </a>
          </div>
          <p className="text-center" data-id="element-25">
            © {new Date().getFullYear()} Desconexión Emocional. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <PopNotification data-id="element-26" />
    </div>;
}